import Navbar from "../primitives/Navbar";
import Home from "./Home";
import Services from "./Services";
import Products from "./Products";
import HeroMessage from "./HeroMessage";
import Footer from "../primitives/Footer";
import Masonry from '../primitives/Masonary';
import { galleryItems } from "../../data/galleryItems";

function HomePage() {
  return (
    <>
      <Navbar />
      <div className="flex-1 m-0 w-full">
        <section id="home" className="w-full">
          <Home showNavbar={false} />
        </section>

        <section id="services" className="w-full">
          <Services />
        </section>

        <section id="products" className="w-full">
          <Products />
        </section>

        {/* Masonry Gallery Section */}
        <section id="gallery" className="w-full py-8 md:py-16]">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="flex justify-center items-center w-full">
              <div className="w-full max-w-7xl mb-[20rem]">
                <Masonry
                  items={galleryItems}
                  ease="power3.out"
                  duration={0.6}
                  stagger={0.05}
                  animateFrom="bottom"
                  scaleOnHover={true}
                  hoverScale={0.95}
                  blurToFocus={true}
                  colorShiftOnHover={false}           
                />
              </div>
            </div>
          </div>
        </section>

        <section id="hero" className="w-full">
          <HeroMessage />
        </section>
      </div>
      <footer id="contact" className="w-full">
        <Footer />
      </footer>
    </>
  );
}

export default HomePage;

